import APIrequest from "../lib/axios";

export const UserService = {
  getAllUsers: async (queryParams = {}) => {
    try {
      const payload = {
        method: "get",
        url: "/users",
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getUser: async (id) => {
    try {
      const payload = {
        method: "get",
        url: `/users/${id}`,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  createUser: async (data) => {
    try {
      const payload = {
        method: "post",
        url: "/users",
        bodyData: data,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  updateUser: async (id, data) => {
    try {
      const payload = {
        method: "put",
        url: `/users/${id}`,
        bodyData: data,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  deleteUser: async (id) => {
    try {
      const payload = {
        method: "delete",
        url: `/users/${id}`,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
